export const user = state => state.users.user
export const session = state => state.users.session
export const tokens = state => state.users.tokens
export const sessionDetails = state => state.users.getSessionUserSuccess
export const GetToken = state => state.users.token
export const loginTimeStamp = state => state.users.loginTimeStamp
export const saveSignUp = state => state.users.registerSignUp
export const registerSignUp = state => state.users.registerSignUp
export const saveCreateProfile = state => state.users.registerCreateProfile
export const registerCreateProfile = state => state.users.registerCreateProfile
export const setupBiometricsConsent = state => state.users.setupBiometricsConsent